module.exports = __webpack_public_path__ + "static/img/img-home-jzg-04.40205b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-04.png
// module id = mOMP
// module chunks = 1